const keywordSearch = {
  state: {
    keywords: null,
    keywordSearchEntries: null,
    keywordSearchContainerDisplay : false,
  },
  getters: {
    keywords(state) { return state.keywords },
    keywordSearchContainerDisplay(state) { return state.keywordSearchContainerDisplay },
    keywordSearchEntries(state) { return state.keywordSearchEntries },
  },
  mutations: {
    setKeywords (state, value) {
      state.keywords = value
    },
    setKeywordSearchEntries (state, value) {
      if (value.length == 0) {
        state.keywordSearchEntries = []
        return
      }
      state.keywordSearchEntries = state.keywordSearchEntries.concat(value)
    },
    setKeywordSearchContainerDisplay (state, value) {
      state.keywordSearchContainerDisplay = value
    },
  },
  actions: {},
  modules: {}
}
export default keywordSearch